export const DefaultCustomizationBannerImage = require('./customization-banner-image.webp');
